import React, { useEffect, useState } from "react";
import { api, fmtDateTime } from "../lib/api";
import { BackToDashboard } from "../components/BackToDashboard";
import { Mail } from "lucide-react";
import { Skeleton } from "../components/ui/skeleton";

export default function AlertHistory() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/alerts/history")
      .then(r => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(e => console.error("Alert history load failed:", e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 sm:px-8 py-8 max-w-5xl mx-auto" data-testid="alert-history-page">
      <BackToDashboard />
      <span className="label-eyebrow">Activity</span>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-2 mb-6">Alert History</h1>

      <div className="border border-zinc-200 bg-white rounded-sm divide-y divide-zinc-100">
        {loading ? (
          <AlertHistorySkeleton />
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-sm text-zinc-500" data-testid="alerts-empty">
            No alerts yet. Status changes on your permits will appear here.
          </div>
        ) : items.map(a => (
          <div key={a.alert_id} className="flex items-start gap-3 px-5 py-3" data-testid={`alert-${a.alert_id}`}>
            <div className="w-7 h-7 rounded-sm flex items-center justify-center bg-blue-100 text-blue-700">
              <Mail size={14} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm">{a.message}</div>
              <div className="text-xs text-zinc-500 mt-0.5">
                <span className="font-mono">{fmtDateTime(a.sent_at)}</span> - {a.channel.toUpperCase()} - {a.job_nickname}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function AlertHistorySkeleton() {
  return (
    <>
      {[...Array(6)].map((_, i) => (
        <div key={i} className="flex items-start gap-3 px-5 py-3" data-testid={`alert-history-skeleton-${i}`}>
          <Skeleton className="w-7 h-7 rounded-sm shrink-0" />
          <div className="flex-1 min-w-0">
            <Skeleton className="h-4 w-4/5 mb-2" />
            <div className="flex flex-wrap gap-2">
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-3 w-12" />
              <Skeleton className="h-3 w-24" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
